import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

  const routes: Routes = [
    {path: '', redirectTo: 'ageVerification', pathMatch: 'full'},
    {
      path: 'landing',
      loadChildren: () => import('./pages/landing/landing.module').then(m => m.LandingModule)
    },
    {
      path: 'recommendations',
      loadChildren: () => import('./pages/recommendations/recommendations.module').then(m => m.RecommendationsModule)
    },
    {
      path: 'ageVerification',
      loadChildren: () => import('./pages/age-verification/age-verification.module').then(m => m.AgeVerificationModule)
    },
    {
      path: 'email',
      loadChildren: () => import('./pages/email-account/email.module').then(m => m.EmailModule)
    },
    {
      path: 'subscription',
      loadChildren: () => import('./pages/subscription/subscription.module').then(m => m.SubscriptionModule)
    },
    {
      path: 'password',
      loadChildren: () => import('./pages/password/password.module').then(m => m.PasswordModule)
    },
    {
      path: 'wifi',
      loadChildren: () => import('./pages/wificode/wifi.module').then(m => m.WifiModule)
    },
    {
      path: 'register',
      loadChildren: () => import('./pages/register/register.module').then(m => m.RegisterModule)
    },
    {
      path: 'consentimiento',
      loadChildren: () => import('./pages/consentimiento/consentimiento.module').then(m => m.ConsentimientoModule)
    },
    {
      path: 'emailValidation',
      loadChildren: () => import('./pages/email-validation/email-validation.module').then(m => m.EmailValidationModule)
    },
    {
      path: 'freeWifi',
      loadChildren: () => import('./pages/free-wifi/freeWifi.module').then(m => m.FreeWifiModule)
    },
    {
      path: 'outRange',
      loadChildren: () => import('./pages/out-range/out-range.module').then(m=>m.OutRangeModule)
    },
    {
      path: '**',
      loadChildren: () => import('./pages/age-verification/age-verification.module').then(m => m.AgeVerificationModule)
    }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
